import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'

import Icon from '../icon'
import {Props as IconProps} from '../icon/icon'

export interface Props<ComponentType extends React.ElementType = 'button'> {
  as?: 'button' | 'a' | ComponentType
  classNames?: string[]
  onClick?: React.MouseEventHandler
  children: React.ReactNode
  href?: string
  icon: IconProps['source']
  target?: string
}

const ContactOptionButton = <ComponentType extends React.ElementType = 'button'>({
  as = 'button',
  classNames,
  children,
  icon,
  href,
  target = '_blank',
  onClick = noop,
}: Props<ComponentType>) => {
  const Component = as
  let props

  const innerContent = (
    <>
      <Icon source={icon} />
      <div className="ContactOptionButton__label">{children}</div>
    </>
  )

  const sharedProps = {
    className: cn('ContactOptionButton', {}, classNames),
    children: innerContent,
    onClick,
  }

  switch (Component) {
    case 'button':
      props = {
        ...sharedProps,
        type: 'button',
      }
      break

    case 'a':
    default:
      props = {
        ...sharedProps,
        target,
        href,
      }
  }

  return <Component {...props} />
}

export default ContactOptionButton
